<template>
	<div
		role="alert"
		:class="cn(alertVariants({ variant }), props.class)"
		v-bind="$attrs"
	>
		<slot />
	</div>
</template>

<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../../utils/cn';

const alertVariants = cva(
	'relative w-full rounded-xl border p-4 flex items-start gap-3 [&>*:first-child]:shrink-0 [&>*:first-child]:mt-0.5',
	{
		variants: {
			variant: {
				default: 'bg-background text-foreground border-border',
				destructive:
					'border-destructive/50 bg-destructive/5 text-destructive [&>*:first-child]:text-destructive',
				success:
					'border-secondary/50 bg-secondary/10 text-secondary-foreground [&>*:first-child]:text-secondary',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
);

type AlertVariants = VariantProps<typeof alertVariants>;

const props = withDefaults(
	defineProps<{
		variant?: AlertVariants['variant'];
		class?: string;
	}>(),
	{
		variant: 'default',
	},
);
</script>
